const EXPAND_COLLAPSE_DURATION_MS = {
  enter: 250,
  exit: 100
};

/** Wraps the resource dropdows and positions it below the header, while at the
 * same time being responsible for rendering the backdrop rendered when the
 * dropdown is open
 */
const backdropCls = "_61b1awgc5i";
const wrapperCls = "_61w1hq7557";
const dropdownCls = "_61ds7sn0k";
const closeButtonCls = "_61cocz7wo";

export { EXPAND_COLLAPSE_DURATION_MS, backdropCls, closeButtonCls, dropdownCls, wrapperCls };
import "./molecule.resource-dropdown.style.linaria.module.css";
//# sourceMappingURL=molecule.resource-dropdown.style.js.map
